import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { SEARCH_ACTIVE_MARKETS } from '../../../../graphql/queries/searchActiveMarkets';
import { ActiveMarket } from '../../../../__generated__/graphql';
import { SortDirection } from '../../../../components/Table/types';
import { ActiveMarketExtended } from '../../../../types/ActiveMarketType';

interface FetchResponseType {
  data: {
    searchActiveMarkets: {
      total: number;
      results: ActiveMarket[];
    };
  };
}

export interface UseFetchAllActiveMarketsParams {
  variables: {
    from?: number;
    pageSize?: number;
    sortFilter?: string;
    sortOrder?: SortDirection;
    wineName?: string;
    isLoggedIn?: boolean;
    filters?: Record<string, string>;
  };
  timeOutBetweenFetch?: number;
  isLoggedIn?: boolean;
  totalCount: number;
  pageSize: number;
}
/* eslint-disable @typescript-eslint/no-unused-vars */

const useAllActiveMarkets = ({ variables, isLoggedIn, totalCount, pageSize }: UseFetchAllActiveMarketsParams) => {
  const [fetchMore] = useLazyQuery(SEARCH_ACTIVE_MARKETS, {
    variables: { ...variables, from: 0, pageSize },
    ...(isLoggedIn ? {} : { context: { serviceName: 'insecure' } }),
  });

  // const response = (fetchResponse?.data ?? {
  //   searchActiveMarkets: { results: [], total: 0 },
  // }) as FetchResponseType;

  // const result = response.searchActiveMarkets.results;

  // if (result.length > 0) fetchResult.push(...result);

  const startFetch = useCallback(async () => {
    if (!totalCount) return [];

    const numberOfPages = Math.floor((totalCount > pageSize ? totalCount : 0) / pageSize);
    const remainingPage = totalCount % pageSize;

    // console.log('numberOfPages ====', numberOfPages);
    // console.log('remainingPage  ===', remainingPage);
    // console.log('totalCount  === ', totalCount);

    const fetchResult: ActiveMarketExtended[] = [];
    const allFetchPromises: Promise<FetchResponseType>[] = [];

    if (numberOfPages <= 0 && remainingPage <= 0) {
      return [];
    }

    /* eslint-disable no-await-in-loop */
    for (let page = 0; page < numberOfPages; page += 1) {
      const fetchResponse = fetchMore({
        variables: { ...variables, from: pageSize * page, pageSize },
        fetchPolicy: 'network-only',
        ...(isLoggedIn ? {} : { context: { serviceName: 'insecure' } }),
      });

      allFetchPromises.push(fetchResponse as unknown as Promise<FetchResponseType>);
    }

    if (remainingPage) {
      // console.log('startSilentFetch-- has remainingPage ', remainingPage);
      // console.log('pageSize * (numberOfPages) ', pageSize * numberOfPages);
      const fetchResponse = fetchMore({
        variables: { ...variables, from: pageSize * numberOfPages, pageSize },
        fetchPolicy: 'network-only',
        ...(isLoggedIn ? {} : { context: { serviceName: 'insecure' } }),
      });

      allFetchPromises.push(fetchResponse as unknown as Promise<FetchResponseType>);
    }

    try {
      const responses = await Promise.all(allFetchPromises);
      responses.forEach((response) => {
        const result = response.data.searchActiveMarkets.results;
        if (result.length > 0) {
          fetchResult.push(...result);
        }
      });
    } catch (error) {
      fetchResult.push(...[]);
      console.log('fetch error');
    }

    return fetchResult.length ? fetchResult : [];
  }, [pageSize, totalCount, variables, fetchMore, isLoggedIn]);

  return { startFetch };
};

/* eslint-enable @typescript-eslint/no-unused-vars */

export default useAllActiveMarkets;
